import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

const animatedComponents = makeAnimated();

const initial_value = {
  user_id: null,
  service_id: "",
  amount: "",
  selected_services: {},
};
let myModal = {};

export default function ModalAddSalaryWork(props: any) {
  const [status, setStatus] = React.useState(0);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [save_data, SetSaveData] = useState(initial_value);
  const [text, setText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  // const [brand_id, SetBrandId] = useState(7);
  // const [outlet_id, SetOutletId] = useState(13);
  const [id_value, SerIdValue] = useState(useParams());

  const [errors, setErrors] = useState({});
  const [userRole, SetUserRole] = useState({});
  const [startDate, setStartDate] = useState(null);
  const [select_date, setSelectedDate] = useState();

  useEffect(() => {
    console.log("ModalAddSalaryWork On mount :", props);
    let myModal1 = document.getElementById("AddServiceModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("event :", event);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModalAddSalaryWork On mount :", props);
      get_service();
      myModal = new bootstrap.Modal(
        document.getElementById("AddServiceModal"),
        {}
      );
      myModal.show();
      console.log("myModal show:", myModal);
    }
  }, [props.open]);

  async function save(event: any) {
    if (event) event.preventDefault();

    if (Object.keys(save_data).length !== 0) {
      // Object.keys(errors).length === 0 &&
      console.log("Form Values :", save_data);

      let pass_data = {
        get: {
          brand: id_value.brand_id,
          outlet: id_value.outlet_id,
        },
        post: {
          user_id: save_data.user_id,
          service_id: save_data.service_id,
          from: select_date,
          amount: save_data.amount,
        },
      };
      let response = await api("/outlet/add_work_salary", pass_data);
      console.log("User post response :", response);
      let item = close_data;
      item.action = "save";
      item.value = response.response.work_salary[0];
      console.log("Close data : ", item);
      SetCloseData(item);
      SetSaveData(initial_value);
      myModal.hide();
    } else {
      alert("There is an Error!");
    }
  }

  function set(name: any, value: any, event: any) {
    // event.persist();
    validate(event, name, value);

    if (name == "service") {
      let old_data = save_data;
      old_data.service_id = value.id;
      old_data.selected_services = value;
      SetSaveData(old_data);
    } else {
      SetSaveData((oldValues) => ({
        ...oldValues,
        [name]: value,
        from: select_date,
        user_id: props.data.id,
      }));
      console.log("SET :", save_data);
    }
  }

  const validate = (event: any, name: any, value: any) => {
    //A function to validate each input values
    console.log("name :", name);
    console.log("value  :", value);
    switch (name) {
      case "service":
        if (value.length <= 0 || value == {} || value == "") {
          setErrors({
            ...errors,
            system_roles: "service roles not vaild",
          });
        } else {
          let newObj = omit(errors, "service");
          setErrors(newObj);
        }
        break;

      case "from":
        if (
          !new RegExp(
            /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/
          ).test(value)
        ) {
          setErrors({
            ...errors,
            mobile: "from should contains date & time",
          });
        } else {
          let newObj = omit(errors, "from");
          setErrors(newObj);
        }
        break;

      case "amount":
        if (value.length <= 0) {
          setErrors({
            ...errors,
            address: "Amount not vaild",
          });
        } else {
          let newObj = omit(errors, "amount");
          setErrors(newObj);
        }
        break;

      default:
        break;
    }
  };

  async function get_service() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        select: true,
      },
    };
    let response = await api("/outlet/services", pass_data);
    console.log("salary get service response :", response.response.services);
    SetUserRole(response.response.services);
    console.log("salary get service set response :", userRole);
  }

  return (
    <div
      className="modal fade"
      id="AddServiceModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              Add Salary Works
            </h5>
            <button
              type="button"
              className="btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <div>
              <p>
                <small>Please fill a correct details</small>
              </p>
              <div className="mt-3">
                <form className="g-3">
                  {/* onSubmit={onSubmit} */}

                  <div className="row">
                    <div className="col-12 col-md-6 mt-3 ">
                      <label className="form-label">Service</label>
                      <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        placeholder="Select service roles"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        // isMulti
                        options={userRole}
                        onChange={(e) => {
                          set("service", e, e);
                        }}
                        // onBlur={() => system_role.onBlur(input.value)}
                        // onChange={(e)=>{
                        //   set('roles', e);
                        // }}
                      />
                    </div>

                    <div className="col-12 col-md-6 mt-3">
                      <label className="form-label">Select Date & Time</label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          let ui = moment(date).format("DD-MM-yyyy h:mm a");
                          console.log("moment ", ui);
                          setSelectedDate(ui);
                          setStartDate(date);
                        }}
                        timeInputLabel="Time:"
                        dateFormat="dd-MM-yyyy h:mm aa"
                        // showTimeInput
                        showTimeSelect
                        // dateFormat="Pp"

                        timeFormat="p"
                        timeIntervals={15}
                        className="form-control"
                      />
                    </div>

                    {save_data.service_id != "" ? (
                      <div className="col-12 mt-2">
                        <div className="row">
                          <div className="col-12 col-md-5 mt-2">
                            <p>
                              <b className="text-dark">Type :</b>
                              <span className="ps-2">
                                {save_data.selected_services.quantity_type == 1
                                  ? "Item Wise"
                                  : "Duration Wise"}
                              </span>
                            </p>
                          </div>
                          <div className="col-12 col-md-3 mt-2">
                            <p>
                              <b className="text-dark">Quantity / Duration :</b>
                              <span className="ps-2">
                                {save_data.selected_services.quantity}
                              </span>
                            </p>
                          </div>
                          <div className="col-12 col-md-3 mt-2">
                            <p>
                              <b className="text-dark">Price :</b>
                              <span className="ps-2">
                                {save_data.selected_services.price}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <div className="col-12 col-md-6 mt-3">
                      <label className="form-label">Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        defaultValue={save_data.amount}
                        required
                        onChange={(e) => {
                          set("amount", e.target.value, e);
                        }}
                      />
                      {errors.amount && (
                        <small className="text-red">{errors.amount}</small>
                      )}
                    </div>
                  </div>
                  {/* )} */}
                </form>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                myModal.hide();
              }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={(e) => {
                save(e);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
